import React, {useState, useEffect, useRef} from 'react';
import {Icon, SearchBar} from 'antd-mobile-v2';
import queryString from 'query-string';
import Scrollbars from 'react-custom-scrollbars-2';
import BackHeader from '@comp/BackHeader/index';
import ListItem from '@comp/DoctorItem/index';
import GstShopSelect from '@/components/GstShopSelect';
import GstDepSelect from '@/components/GstDepSelect';
import GstDateSelect from '@/components/GstDateSelect';
import GstFilter from '@/components/GstFilter';
import * as DoctorService from '@/store/api/doctor';
import {getLocationByTxMap} from '@/utils/getLocation';
import {locationTo, storage} from '@utils/tools';
import {isWeiXin} from '@utils/weixin';
import IconDz from '@/assets/icons/dz.png';
import DayJs from 'dayjs';
import './index.less';
import Cookie from 'js-cookie';

const FILTER_CACHE_KEY = 'doctor_list_filter';

function Index(props) {
  let {city_code, shop_no, dept_no, video, schedule_date, from, refer, txRegisteredCallback} = queryString.parse(
    props.location.search
  );
  city_code = Number(city_code || 0);
  video = Number(video || 0);
  const localStorageFilter = storage.get(FILTER_CACHE_KEY, 'session') || {};
  if (+schedule_date === 1) {
    localStorageFilter.date = [Number(DayJs().format('YYYYMMDD'))];
  } else {
    localStorageFilter.date = localStorageFilter.times;
  }
  const isOmo = from === 'omo';
  const scrollRef = useRef(null);
  const [shop_id, setShopId] = useState(shop_no || 0);
  const [oidx, setOidx] = useState(-1);
  const [sortSelectIdx, setSortSelectIdx] = useState(localStorageFilter.sort_type || 0);
  const [loading, setLoading] = useState(false);
  const [isFetch, setIsFetch] = useState(false);
  const [doctorData, setDoctorData] = useState({doctor_list: [], current_page: 0, total_page: 0});
  const [params, setParamsHook] = useState({
    query_type: 1,
    page_no: 1,
    page_size: 10,
    doctor_name: '',
    shop_no,
    dept_no: 0,
    city_no: city_code,
    property: video,
    sort_type: 0,
    lat: '',
    lon: '',
    ...localStorageFilter,
  });
  function setParams(data) {
    console.log(data);
    setParamsHook(data);
    storage.set(FILTER_CACHE_KEY, data, 'session');
  }
  const sortArr = [
    {txt: '智能推荐', id: 0},
    {txt: '回诊率高', id: 1},
    {txt: '距离最近', id: 2},
    {
      txt: '门诊量多',
      id: 3,
    },
    {txt: '好评率高', id: 4},
  ];

  useEffect(() => {
    queryDocList();
  }, [isFetch]);

  useEffect(() => {
    if (refer) {
      Cookie.set('refer', refer, {expires: 1});
    }

    if (txRegisteredCallback) {
      Cookie.set('txRegisteredCallback', txRegisteredCallback, {expires: 1});
    } else {
      Cookie.remove('txRegisteredCallback');
    }

    if (isOmo) {
      document.title = '医生列表';
      localStorage.setItem('from', 'omo');
    } else {
      localStorage.removeItem('form');
    }

    getLocationByTxMap(
      data => {
        const {lat, lng} = data;
        params.lat = lat;
        params.lon = lng;
        setParams({...params});
      },
      res => {
        // alert(`err: ${JSON.stringify(res)}`);
      }
    );
  }, []);

  const queryDocList = async isScroll => {
    setLoading(true);
    if (!params.city_no) {
      delete params.city_no;
    }
    const {times, ...rest} = params;
    const {status, message, doctor_list, current_page, total_page} = await DoctorService.fetchDoctorList(rest);
    if (status === 0) {
      const list = isScroll ? [...doctorData.doctor_list, ...doctor_list] : doctor_list || [];
      setDoctorData({
        doctor_list: list,
        current_page,
        total_page,
      });
      if (!isScroll && scrollRef.current) scrollRef.current.scrollToTop();
    } else {
    }
    setLoading(false);
  };

  const onChangeShop = ({shopInfo, cityInfo}) => {
    // console.log(shopInfo)
    console.log('执行onChangeShop');
    setParams({...params, shop_no: shopInfo.shop_no, city_no: cityInfo.city_no});
    // setIsFetch(!isFetch);
  };

  const onSelectDep = data => {
    console.log('执行onSelectDep');
    setParams({...params, dept_no: data.dept_no, disease_id: []});
    setIsFetch(!isFetch);
  };

  const onSelectDate = data => {
    console.log('设置时间');
    let days = {};
    if (schedule_date != 1) {
      days.times = data.dates;
    }
    days.date = data.dates;
    setParams({...params, ...days});
    setIsFetch(!isFetch);
  };

  const onSelectFilter = data => {
    console.log('执行onSelectFilter');
    setParams({...params, ...data});
    setIsFetch(!isFetch);
  };

  const onToggle = (idx, data) => {
    if (data) {
      setOidx(data);
    } else {
      setOidx(idx);
    }
  };

  // 智能排序
  const onSort = (idx, data) => {
    setSortSelectIdx(idx);
    setParams({...params, sort_type: data.id});
    setIsFetch(!isFetch);
  };

  const handleScroll = () => {
    const scroll = scrollRef.current;
    const {current_page, total_page} = doctorData;
    let sH = scroll.getScrollHeight(),
      sT = scroll.getScrollTop(),
      sC = scroll.getClientHeight();
    if (sH && sH <= Math.ceil(sT) + sC + 50 && current_page < total_page && !loading) {
      params.page_no += 1;
      setParams({...params});
      queryDocList(true);
    }
  };

  const renderList = () => {
    return (
      <>
        {doctorData.doctor_list.length &&
          doctorData.doctor_list.map(item => (
            <ListItem key={item.doctor_id} refer={refer} data={item} isOmo={isOmo} dept_no={''} />
          ))}
      </>
    );
  };

  const onRoute = url => {
    if (isWeiXin() && isOmo) {
      let wx = window.wx || {};
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          //H5向小程序传值的方法会在特定的时间触发，因此需要我们手动写一个跳转（也可以写后退和摧毁，分享，以需求而定）
          wx.miniProgram.navigateTo({
            url: `/pages/mobileView/index?url=${encodeURIComponent(location.origin + url)}`, //这里是小程序页面
          });
        } else {
          //非小程序环境下逻辑
          console.log('不在小程序中');
        }
      });
    } else {
      locationTo(url);
    }
  };
  // console.log('获取params', params);
  return (
    <section className={`page-doc-list ${isOmo ? 'omo' : ''}`}>
      {isOmo ? null : <BackHeader title={+video === 2 ? '视频看诊' : '快速预约'} />}
      <div className="search-input-box">
        <SearchBar
          className="search-input"
          placeholder="搜索医生 / 疾病 / 分院"
          showCancelButton={false}
          disabled={true}
        />
        <div className="mask" onClick={() => onRoute(`/search?=${city_code}`)} />
      </div>
      <div className="option-wrapper">
        <div className="option d-flex">
          <GstShopSelect
            onChangeShop={data => onChangeShop(data)}
            onToggle={data => onToggle(0, data)}
            isShow={oidx === 0}
            city_code={params.city_no || city_code}
            shop_id={params.shop_no || shop_no}
            lat={params.lat}
            lon={params.lon}
          />
          <GstDepSelect
            onSelect={data => onSelectDep(data)}
            onToggle={data => onToggle(1, data)}
            isShow={oidx === 1}
            city_no={params.city_no}
            shop_no={params.shop_no}
            dept_no={params.dept_no || dept_no}
          />
          <GstDateSelect
            onSelect={data => onSelectDate(data)}
            onToggle={data => onToggle(2, data)}
            isShow={oidx === 2}
            data={{key: 2, schedule_date}}
            defaultValue={params.date}
          />
          <GstFilter
            onSelect={data => onSelectFilter(data)}
            onToggle={data => onToggle(3, data)}
            isShow={oidx === 3}
            data={{key: 3}}
            defaultValue={{price: params.price, title: params.title, property: params.property, number: params.number}}
            video={video}
          />
        </div>
      </div>
      <div className="sort-list">
        {sortArr.map((item, idx) => (
          <span
            onClick={() => onSort(idx, item)}
            key={idx}
            className={`sort-list-item ${idx === sortSelectIdx && 'active'}`}
          >
            {item.txt}
          </span>
        ))}
      </div>
      <div className="dz">
        <a className="dz-cont" href="https://miying.qq.com/guide-h5/home?appid=wxc04ce1d87dcd13cd">
          <img src={IconDz} alt="" />
          <span className="label">智能导诊</span>
          <span className="txt">试试人工智能服务</span>
          <Icon type="right" color="#979797" />
        </a>
      </div>
      <div className="search-list">
        {doctorData.doctor_list.length ? (
          <Scrollbars ref={scrollRef} onScroll={() => handleScroll()}>
            {renderList()}
            <div className="tip">数据加载到底啦~</div>
          </Scrollbars>
        ) : (
          <p className="empty-data">暂无数据</p>
        )}
      </div>
    </section>
  );
}

export default Index;
